/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Conversations_EmptyInputs */

const en_us2_coach_extra_conversations_empty = /** @type {(inputs: Coach_Extra_Conversations_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No conversations yet.`)
};

const pt_br2_coach_extra_conversations_empty = /** @type {(inputs: Coach_Extra_Conversations_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma conversa ainda.`)
};

const es_419_coach_extra_conversations_empty = /** @type {(inputs: Coach_Extra_Conversations_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay conversaciones.`)
};

const pt_pt2_coach_extra_conversations_empty = /** @type {(inputs: Coach_Extra_Conversations_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não há conversas.`)
};

const fr_fr2_coach_extra_conversations_empty = /** @type {(inputs: Coach_Extra_Conversations_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune conversation pour l'instant.`)
};

const de_de2_coach_extra_conversations_empty = /** @type {(inputs: Coach_Extra_Conversations_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Unterhaltungen.`)
};

const it_it2_coach_extra_conversations_empty = /** @type {(inputs: Coach_Extra_Conversations_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna conversazione.`)
};

/**
* | output |
* | --- |
* | "No conversations yet." |
*
* @param {Coach_Extra_Conversations_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_conversations_empty = /** @type {((inputs?: Coach_Extra_Conversations_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Conversations_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_conversations_empty(inputs)
	if (locale === "es-419") return es_419_coach_extra_conversations_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_conversations_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_conversations_empty(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_conversations_empty(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_conversations_empty(inputs)
	return en_us2_coach_extra_conversations_empty(inputs)
});
export { coach_extra_conversations_empty as "coach-extra.conversations_empty" }